import {
  FilterMode,
  DashboardLayoutTemplateCreateMutationVariables,
  DashboardLayoutTemplate_OrderBy,
  DashboardLayoutTemplate,
  SortOrder,
  DashboardLayoutTemplate_Filter,
} from "../../../api/graphql";
import { getApiInstance } from "../../../api";
import { nullToUndefinedRecursive } from "../../../common/utils";
import { buildCreateOne } from "../../common/services/crudServices";

export const dashboardLayoutTemplateService = {
  createOne: buildCreateOne(
    (
        dashboardLayoutTemplateCreateVariables: DashboardLayoutTemplateCreateMutationVariables
      ) =>
      async (token: string, activityStore: any) => {
        const api = getApiInstance(token, activityStore);
        const result = await api.dashboardLayoutTemplateCreate(
          dashboardLayoutTemplateCreateVariables
        );
        return result.dashboardLayoutTemplateCreate;
      }
  ),
  getOne: async (id: string, accessToken: string, activityStore: any) => {
    const api = getApiInstance(accessToken, activityStore);
    const result = await api.dashboardLayoutTemplateOne({ id });
    return result.dashboardLayoutTemplateOne as DashboardLayoutTemplate;
  },
  getFilteredList: async (
    accessToken: string,
    offset: number,
    take: number,
    searchValue: string,
    _language: string = "es",
    orderBy: DashboardLayoutTemplate_OrderBy[] | null = null,
    filter: DashboardLayoutTemplate_Filter | null = null,
    activityStore: any
  ) => {
    const api = getApiInstance(accessToken, activityStore);

    let where: DashboardLayoutTemplate_Filter | undefined;
    if (searchValue !== "") {
      where = { name: { contains: searchValue, mode: FilterMode.Insensitive } };
    }

    if (filter) {
      if (where) {
        where = { AND: [filter, where] };
      } else {
        where = filter;
      }
    }

    const result = await api.dashboardLayoutTemplateListWithOffset({
      offset,
      take,
      orderBy: orderBy ? orderBy : [{ name: SortOrder.Asc }],
      where,
    });
    const list = nullToUndefinedRecursive(
      result.dashboardLayoutTemplateListWithOffset
    ) as DashboardLayoutTemplate[];
    return { list, orderBy };
  },
};
